import { Component, OnInit, Input, Output } from '@angular/core';
import { VaultResource } from '../../../../core/resources/vault-resource';
import { FormBuilder, FormGroup, Validators, FormArray, AbstractControl } from '@angular/forms';
import { Observable, Subject, BehaviorSubject } from 'rxjs';
import { ApiService } from '../../../../core/services/api.service';
import { SweetAlertService } from '../../../../core/services/sweet-alert.service';

@Component({
  selector: 'app-export-vouchers',
  templateUrl: './export-vouchers.component.html',
  styleUrls: ['./export-vouchers.component.scss']
})
export class ExportVouchersComponent implements OnInit {

  @Input() public vault: VaultResource;
  @Output() public valueChanged = new Subject<FormGroup>();

  public headers = ['vendor', 'value', 'numberOfVouchers', 'actions'];
  public ds = new BehaviorSubject<AbstractControl[]>([]);

  public frm: FormGroup;
  public cfg: FormGroup;
  public assets: FormArray;

  constructor(private readonly fb: FormBuilder, private readonly api: ApiService, private readonly sw: SweetAlertService) {

    this.assets = fb.array([]);

    this.cfg = fb.group({
      vault: [null, Validators.required],
      expired: [false, Validators.nullValidator],
      expiresBefore: [null, Validators.nullValidator],
      assets: this.assets
    });

    this.frm = fb.group({
      type: ['Voucher', Validators.required],
      name: [null, Validators.required],
      configuration: this.cfg
    });
  }

  public ngOnInit() {

    this.cfg.get('vault').setValue(this.vault.id);
    this.notifyChanged();
    this.refreshRef();
  }

  private refreshRef(): void {

    if (!this.vault) {
      return;
    }

    const filter = { testCodes: 'false' };
    console.log(this.vault);

    this.api.list(this.vault._links.statistics_available.href, filter).subscribe((data: any[]) => {
      data.forEach(item => {
        console.log(item);
        this.assets.push(this.addExportAsset(item));
      });
      this.notifyChanged();
    });
  }

  public onChange() {
    this.valueChanged.next(this.frm);
  }

  public remove(index: number, ev: Event): void {

    ev.preventDefault();
    this.assets.removeAt(index);
    this.notifyChanged();
  }

  private addExportAsset(stat: any): FormGroup {
    return this.fb.group({
      vendor: [{ value: stat.vendor.nameNormalized, disabled: true }, Validators.required],
      value: [{ value: stat.voucherValue, disabled: true }, Validators.required],
      numberOfVouchers: [stat.available, Validators.required]
    });
  }

  public notifyChanged(ev?: Event) {

    if (ev) {
      ev.preventDefault();
    }
    if (this.frm.valid) {
      this.frm.enable();
      this.valueChanged.next(this.frm);
      this.disableAssetFields();
    }
    this.frm.markAsDirty();
    this.ds.next(this.assets.controls);
  }

  private disableAssetFields() {
    this.assets.controls.forEach(i => {
      i.get('vendor').disable();
      i.get('value').disable();
    });
  }
}
